// src/reducers/tasks/addOrEdit/index.js

import { combineReducers } from 'redux'
import ActionType from '../../../actions/ActionType'
import snackbar from './snackbar'
import select from './select'
import generalPanelExpanded from './generalPanelExpanded'
import saveAttempted from './saveAttempted'
import { parseDate } from 'chrono-node'
import automationTypeSelected from './automationTypeSelected'
import splitFormDisplayed from './splitFormDisplayed'
import campaignSelected from './campaignSelected'
import stageSelected from './stageSelected'
import actionTypePanelExpanded from './actionTypePanelExpanded'
import groupSelected from './groupSelected'
import groupToAddToSelected from './groupToAddToSelected'
import groupToRemoveFromSelected from './groupToRemoveFromSelected'
import contactsSelectedForGroup from './contactsSelectedForGroup'
import delay from './delay'
// import whenToTrigger from './whenToTrigger'
import bottomNavigation from './bottomNavigation'
import delayUnit from './delayUnit'
import taskTypeIDToNameMap from 'utils/taskTypeIDToNameMap'
import fromNumberSelected from './fromNumberSelected'
import managePhonesModalOpen from './managePhonesModalOpen'
import originalStageSelected from './originalStageSelected'
import originalCampaignSelected from './originalCampaignSelected'
import assignmentPoolSelected from './assignmentPoolSelected'
import mediaUrl from './mediaUrl'
import mergeFieldsPreviewSelect from './mergeFieldsPreviewSelect'
import fromEmailSelected from './fromEmailSelected'
import fromName from './fromName'
import campaignSelectedToRemoveContactFrom from './campaignSelectedToRemoveContactFrom'
import endpointSelected from './endpointSelected'

const smartTask = (state = { focused: false }, action) => {
  switch (action.type) {
    case ActionType.Tasks.SMART_TASK_FOCUS:
      return { focused: true }
    case ActionType.Tasks.SMART_TASK_BLUR:
      return { focused: false }
    default:
      return state
  }
}

const fields = (
  state = {
    smartTask: { value: '', initialValue: '' },
    name: { value: '', initialValue: '' },
    selectedActionPrediction: { value: '', initialValue: '' },
    date: { value: null, initialValue: null },
    time: { value: null, initialValue: null },
    dateErrorOpen: false,
    use_owner_from_number: { value: true, initialValue: true },
    use_owner_from_address: { value: true, initialValue: true },
  },
  action,
) => {
  switch (action.type) {
    case ActionType.Contacts.CREATE_TASK_WITH_CONTACT:
      return {
        ...state,
        selectedActionPrediction: {
          ...state.selectedActionPrediction,
          value: action.payload.taskType,
        },
      }
    case ActionType.Tasks.VALIDATION_FAILURE:
      const dup = state
      const pathStateMap = {
        '.description': 'smartTask',
        '.name': 'name',
        '.send_email.when_to_send': 'date',
        '.send_sms.when_to_send': 'date',
      }

      action.errors.forEach(error => {
        if (pathStateMap[error.dataPath]) {
          dup[pathStateMap[error.dataPath]].error = error.message
        }
      })

      return dup
    case ActionType.Tasks.HANDLE_FIELD_CHANGE:
      return {
        ...state,
        [action.payload.name]: {
          initialValue: state[action.payload.name].initialValue,
          value: action.payload.value,
        },
      }
    case ActionType.Tasks.HANDLE_CALENDAR_CHANGE:
      return {
        ...state,
        date: {
          initialValue: state.date.initialValue,
          value: action.payload,
        },
      }
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload) {
        const smartTask = {
          value: action.payload.description
            ? action.payload.description
            : state.smartTask.value,
          initialValue: action.payload.description
            ? action.payload.description
            : state.smartTask.initialValue,
        }

        const name = {
          value: action.payload.name ? action.payload.name : state.name.value,
          initialValue: action.payload.name
            ? action.payload.name
            : state.name.value,
        }

        const payload_name =
          taskTypeIDToNameMap?.[action.payload?.task_type_id]?.payload_name
        const taskType =
          taskTypeIDToNameMap?.[action.payload?.task_type_id]?.name

        const time = { value: null, initialValue: null }
        const wallclock = action.payload?.[payload_name]?.post_delay_wallclock
        if (wallclock) {
          const [hours, minutes] = wallclock.split(':').map(Number)
          const date = new Date()
          // Set the UTC time
          date.setUTCHours(hours, minutes, 0, 0)
          // Convert UTC to local time
          const localDate = new Date(
            date.toLocaleString('en-US', {
              timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            }),
          )
          time.value = localDate
          time.initialValue = localDate
        }

        const date = {
          value: action.payload?.[payload_name]?.when_to_send
            ? new Date(action.payload[payload_name].when_to_send)
            : state.date.value,
          initialValue: action.payload?.[payload_name]?.when_to_send
            ? new Date(action.payload[payload_name].when_to_send)
            : state.date.initialValue,
        }

        const selectedActionPrediction = {
          value: taskType,
          initialValue: taskType,
        }

        const use_owner_from_number = {
          value:
            action.payload?.[payload_name]?.trigger_data
              ?.use_owner_from_number || false,
          initialValue:
            action.payload?.[payload_name]?.trigger_data
              ?.use_owner_from_number || false,
        }

        const use_owner_from_address = {
          value:
            action.payload?.[payload_name]?.trigger_data
              ?.use_owner_from_address || false,
          initialValue:
            action.payload?.[payload_name]?.trigger_data
              ?.use_owner_from_address || false,
        }

        return {
          ...state,
          smartTask,
          name,
          selectedActionPrediction,
          date,
          time,
          use_owner_from_number,
          use_owner_from_address,
        }
      }

      return {
        ...state,
        smartTask: { value: '', initialValue: '' },
        name: { value: '', initialValue: '' },
        selectedActionPrediction: {
          value: '',
          initialValue: '',
        },
        date: action.date
          ? {
              value: new Date(action.date),
              initialValue: new Date(action.date),
            }
          : {
              value: null,
              initialValue: null,
            },
        time: { value: null, initialValue: null },
        use_owner_from_number: { value: true, initialValue: true },
        use_owner_from_address: { value: true, initialValue: true },
      }
    case ActionType.LUIS.GET_SUCCESS:
      let newIntent = state.selectedActionPrediction.value
      const intent = action.payload.body.topScoringIntent.intent
      if (intent === 'Send Email' || intent === 'Send SMS') {
        newIntent = intent === 'Send Email' ? 'email' : 'sms'
      }
      let date = state.date.value
      let dateErrorOpen = state.dateErrorOpen
      let parsedDate = null
      if (action.payload.body.entities.length) {
        action.payload.body.entities.forEach(entity => {
          if (
            entity.type === 'builtin.datetimeV2.date' ||
            entity.type === 'builtin.datetimeV2.datetime'
          ) {
            parsedDate =
              entity.resolution &&
              entity.resolution.values &&
              entity.resolution.values[0]
                ? parseDate(entity.resolution.values[0].value)
                : null
            if (parsedDate !== null && parsedDate >= Date.now()) {
              date = parsedDate
            } else {
              dateErrorOpen = true
            }
          }
          if (entity.type === 'builtin.datetimeV2.time') {
            const parsedDateWithTime =
              entity.resolution &&
              entity.resolution.values &&
              entity.resolution.values[0]
                ? parseDate(entity.resolution.values[0].value, date)
                : null
            if (parsedDateWithTime !== null) {
              date = parsedDateWithTime
            }
          }
        })
      }
      return {
        ...state,
        selectedActionPrediction: {
          ...state.selectedActionPrediction,
          value: newIntent,
        },
        date: {
          ...state.date,
          value: date,
        },
        dateErrorOpen,
      }
    case ActionType.Tasks.CLOSE_DATE_ERROR:
      return {
        ...state,
        dateErrorOpen: false,
      }
    default:
      return state
  }
}

const selectedTemplate = (
  state = { value: 'new', initialValue: 'new' },
  action,
) => {
  switch (action.type) {
    case ActionType.Tasks.HANDLE_TEMPLATE_CHANGE:
      return {
        initialValue: action.payload ? action.payload.id : 'new',
        value: action.payload ? action.payload.id : 'new',
      }
    case ActionType.Tasks.RECEIVE_TASK:
      return action.payload
        ? action.payload.send_email
          ? {
              value: action.payload.send_email.trigger_data.template_id,
              initialValue: action.payload.send_email.trigger_data.template_id,
            }
          : { value: 'new', initialValue: 'new' }
        : { value: 'new', initialValue: 'new' }
    default:
      return state
  }
}

const selectedTheme = (
  state = { value: null, initialValue: 'new' },
  action,
) => {
  switch (action.type) {
    case ActionType.Tasks.HANDLE_THEME_CHANGE:
      return { ...state, value: action.payload }
    default:
      return state
  }
}

const emailTemplateSelectOpen = (state = false, action) => {
  switch (action.type) {
    case ActionType.Tasks.OPEN_TEMPLATE_SELECT:
      return true
    case ActionType.Tasks.CLOSE_TEMPLATE_SELECT:
      return false
    default:
      return state
  }
}

const templateChanged = (state = false, action) => {
  switch (action.type) {
    case ActionType.Tasks.HANDLE_TEMPLATE_EDIT:
      return true
    default:
      return state
  }
}

const emailCardSelected = (state = [null], action) => {
  switch (action.type) {
    case ActionType.Tasks.SELECT_EMAIL_CARD:
      let newState = state
      newState.push(action.payload)
      return newState
    case ActionType.Tasks.BACK_BUTTON:
      let newArray = state
      newArray.pop()
      return newArray
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload) {
        if (action.payload.send_email) {
          return [...state, 'blank']
        }
      } else {
        return [null]
      }
      return state
    default:
      return state
  }
}

export const templateName = (
  state = { value: '', initialValue: '' },
  action,
) => {
  switch (action.type) {
    case ActionType.Tasks.HANDLE_TEMPLATE_CHANGE:
      return {
        initialValue: action.payload ? action.payload.name : '',
        value: action.payload ? action.payload.name : '',
      }
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload && action.payload.send_email) {
        const value =
          action.templatesByID[
            action.payload.send_email.trigger_data.template_id
          ].name
        return { value, initialValue: value }
      }
      return state
    case ActionType.Tasks.HANDLE_TEMPLATE_NAME_CHANGE:
      return {
        ...state,
        value: action.payload,
      }
    default:
      return state
  }
}

export const subject = (state = { value: '', initialValue: '' }, action) => {
  switch (action.type) {
    case ActionType.Tasks.HANDLE_TEMPLATE_CHANGE:
      return {
        initialValue: action.payload ? action.payload.Template.SubjectPart : '',
        value: action.payload ? action.payload.Template.SubjectPart : '',
      }
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload && action.payload.send_email) {
        const value =
          action.templatesByID[
            action.payload.send_email.trigger_data.template_id
          ].Template.SubjectPart
        return { value, initialValue: value }
      }
      return state
    case ActionType.Tasks.HANDLE_SUBJECT_CHANGE:
      return {
        ...state,
        value: action.payload,
      }
    default:
      return state
  }
}

export const emailEditor = (
  state = { value: '', initialValue: '', innerText: '' },
  action,
) => {
  switch (action.type) {
    case ActionType.Tasks.EMAIL_EDITOR_CHANGE:
      return {
        ...state,
        value: action.payload.innerHtml,
        innerText: action.payload.innerText
          ? action.payload.innerText
          : state.innerText,
      }
    case ActionType.Tasks.CODE_EDITOR_CHANGE:
      return {
        ...state,
        value: action.payload.innerHtml,
      }
    case ActionType.Tasks.HANDLE_TEMPLATE_CHANGE:
      if (action.payload) {
        return {
          initialValue: action.payload.Template.HtmlPart,
          value: action.payload.Template.HtmlPart,
          innerText: action.payload.Template.TextPart,
        }
      }
      return {
        ...state,
        value: '',
        innerText: '',
      }
    case ActionType.Tasks.HANDLE_THEME_CHANGE:
      return {
        ...state,
        value: action.payload,
      }
    case ActionType.Tasks.PASTE_TAG:
      return {
        ...state,
        innerHtml: action.payload.innerHtml,
      }
    case ActionType.Tasks.PASTE_SNIPPET:
      return {
        ...state,
        innerHtml: action.payload.innerHtml,
      }
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload && action.payload.send_email) {
        const template =
          action.templatesByID[
            action.payload.send_email.trigger_data.template_id
          ].Template
        const value = template.HtmlPart
        const innerText = template.TextPart
        return { value, initialValue: value, innerText }
      }
      return state
    default:
      return state
  }
}

export const defaultValues = (state = {}, action) => {
  switch (action.type) {
    case ActionType.Tasks.HANDLE_TEMPLATE_CHANGE:
      if (action.payload) {
        return action.payload.default_template_values
      }
      return {}
    case ActionType.Tasks.PASTE_TAG:
      if (!state[action.payload.tag.slice(3, -3)]) {
        return { ...state, [action.payload.tag.slice(3, -3)]: '' }
      }
      return state
    case ActionType.Tasks.DEFAULT_VALUE_CHANGE:
      return { ...state, [action.payload.defaultValue]: action.payload.value }
    default:
      return state
  }
}

export const snippetsPanelExpanded = (state = true, action) => {
  switch (action.type) {
    case ActionType.Tasks.TOGGLE_SNIPPETS_PANEL:
      return !state
    default:
      return state
  }
}

export const variablesPanelExpanded = (state = true, action) => {
  switch (action.type) {
    case ActionType.Tasks.TOGGLE_VARIABLES_PANEL:
      return !state
    default:
      return state
  }
}

export const codeEditorDisplayed = (state = false, action) => {
  switch (action.type) {
    case ActionType.Tasks.CLICK_CODE_BUTTON:
      return !state
    default:
      return state
  }
}

export const sms = (state = { value: '', initialValue: '' }, action) => {
  switch (action.type) {
    case ActionType.Tasks.ADD_SMS:
      return { value: action.payload, initialValue: state.initialValue }
    case ActionType.Tasks.RECEIVE_TASK:
      if (action?.payload?.send_sms) {
        const templateID = action.payload.send_sms.trigger_data?.template_id
        const template = action.smsTemplatesByID?.[templateID]

        if (template) {
          return {
            value: template.Template?.TextPart,
            initialValue: template.Template?.TextPart,
          }
        }
        return {
          value: action.payload.send_sms.trigger_data?.body,
          initialValue: action.payload.send_sms.trigger_data?.body,
        }
      }
      return {
        value: '',
        initialValue: '',
      }
    case ActionType.Email.Templates.RECEIVE_TEMPLATE:
      if (action?.payload?.type === 'sms') {
        return {
          value: action?.payload?.Template?.TextPart,
          initialValue: action?.payload?.Template?.TextPart,
        }
      }
      return { value: '', initialValue: '' }
    case ActionType.Tasks.VALIDATION_FAILURE:
      const dup = state
      action.errors.forEach(error => {
        if (error.dataPath === '.send_sms.trigger_data.body') {
          dup.error = error.message
        }
      })
      return dup
    default:
      return state
  }
}

export const taskID = (state = 'new', action) => {
  switch (action.type) {
    case ActionType.Tasks.RECEIVE_TASK:
      return action.payload?.id || 'new'
    default:
      return state
  }
}

export default combineReducers({
  codeEditorDisplayed,
  defaultValues,
  emailCardSelected,
  emailEditor,
  emailTemplateSelectOpen,
  fields,
  select,
  selectedTemplate,
  selectedTheme,
  smartTask,
  sms,
  snippetsPanelExpanded,
  snackbar,
  subject,
  taskID,
  templateChanged,
  templateName,
  variablesPanelExpanded,
  generalPanelExpanded,
  saveAttempted,
  automationTypeSelected,
  splitFormDisplayed,
  campaignSelected,
  stageSelected,
  actionTypePanelExpanded,
  groupSelected,
  groupToAddToSelected,
  groupToRemoveFromSelected,
  contactsSelectedForGroup,
  delay,
  // whenToTrigger,
  bottomNavigation,
  delayUnit,
  fromNumberSelected,
  managePhonesModalOpen,
  originalStageSelected,
  originalCampaignSelected,
  assignmentPoolSelected,
  mediaUrl,
  mergeFieldsPreviewSelect,
  fromEmailSelected,
  fromName,
  campaignSelectedToRemoveContactFrom,
  endpointSelected,
})
